var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase } from "@ane/core/lib/services/RestServiceBase";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let SRMCheckResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.legacy, "/xCardApi/");
    __publicField(this, "_errorMessage", (RestResult2, response) => {
      return response && response.ExceptionMessage;
    });
  }
  loadWarnings(workspaceId, scorecardIds) {
    return __async(this, null, function* () {
      var finalResult = [];
      let result = {};
      do {
        var sc = scorecardIds.pop();
        let address = `workspaces/${workspaceId}/scorecards/${sc}/warnings?api-version=2022-12-01-internal&warningType=SampleRatioMismatch&top=100&skip=0&includeAlert=true`;
        result = yield this._get(address);
        if (result.statusCode === 400) {
          return result;
        }
        result = result.getSuccessData(this._errorMessage);
        finalResult = finalResult.concat(result.value);
      } while (scorecardIds.length > 0);
      return { value: finalResult };
    });
  }
  loadWarningAsync(workspaceId, sc) {
    return __async(this, null, function* () {
      let address = `workspaces/${workspaceId}/scorecards/${sc}/warnings?api-version=2022-12-01-internal&warningType=SampleRatioMismatch&top=100&skip=0&includeAlert=true`;
      return yield this._get(address);
    });
  }
};
SRMCheckResource = __decorateClass([
  WPSProxyConverter()
], SRMCheckResource);
const SRMCheck_resource = new SRMCheckResource();
export {
  SRMCheck_resource as default
};
//# sourceMappingURL=SRMCheck.resource.js.map
